export default __webpack_public_path__ + "static/media/meet2.ae4d06d8.png";